import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';
import { ControlContainer, NgForm } from '@angular/forms';
import { Experience } from '../../applicant-service/service-models/experience';
import { EmploymentHistoryConfiguration } from '../../job-service/service-models/employment-history-configuration';
import * as _ from 'lodash';

@Component({
  selector: 'app-experience',
  templateUrl: './experience.component.html',
  styleUrls: ['./experience.component.scss'],
  viewProviders: [{ provide: ControlContainer, useExisting: NgForm }]
})
export class ExperienceComponent implements OnInit {
  @Output() remove = new EventEmitter();
  @Input()
  index: number;
  @Input()
  experience: Experience;
  @Input()
  configuration: EmploymentHistoryConfiguration;
  provinces = ['AK',
    'AL',
    'AR',
    'AZ',
    'CA',
    'CO',
    'CT',
    'DC',
    'DE',
    'FL',
    'GA',
    'HI',
    'IA',
    'ID',
    'IL',
    'IN',
    'KS',
    'KY',
    'LA',
    'MA',
    'MD',
    'ME',
    'MI',
    'MN',
    'MO',
    'MS',
    'MT',
    'NC',
    'ND',
    'NE',
    'NH',
    'NJ',
    'NM',
    'NV',
    'NY',
    'OH',
    'OK',
    'OR',
    'PA',
    'RI',
    'SC',
    'SD',
    'TN',
    'TX',
    'UT',
    'VA',
    'VT',
    'WA',
    'WV',
    'WI',
    'WY'];
  randomNumber: number;

  constructor() {
    this.randomNumber = Math.random();
  }

  adjustRelatedFieldsToCurrentlyEmployed() {
    if (this.experience.currentlyEmployed) {
      this.experience.endDate = null;
    }
  }

  ngOnInit() {
  }

  onEndDateChanged($event) {
    const changedDate = this.parseDateString($event);

    if (changedDate !== undefined) { this.experience.endDate = changedDate; }
  }

  onStartDateChanged($event) {
    const changedDate = this.parseDateString($event);

    if (changedDate !== undefined) { this.experience.startDate = changedDate; }
  }

  startsWithSearchFn(term: string, item: string) {
    return item.toLowerCase().startsWith(term.toLowerCase());
  }

  parseDateString($event: string): Date {
    const dateParts = $event.split('/');

    if (dateParts.length !== 2 || dateParts[1].length < 4 || dateParts[0].length < 2 || (isNaN(+dateParts[1]) || isNaN(+dateParts[0]))) {
      return undefined;
    }

    return new Date(+dateParts[1], +dateParts[0] - 1);
  }
}
